<!--
 * @Author: baike
 * @LastEditors: baike
-->
<template>
  <div class="title">
    <div class="title_text">
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
  name: "Title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang='scss' scoped>
.title {
  width: 100%;
  .title_text {
    font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    color: #333333;
  }
}
</style>